// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3vOj_","errors":"Errors_errors__vJEF8"};